"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var react_2 = require("swiper/react");
var Slide_1 = __importDefault(require("./Slide"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
require("./styles.scss");
var DesktopGames = function (_a) {
    var preparedCollections = _a.preparedCollections, _b = _a.navigationPosition, navigationPosition = _b === void 0 ? 'top' : _b, _c = _a.withIcon, withIcon = _c === void 0 ? false : _c;
    var t = (0, next_intl_1.useTranslations)('translation');
    var slider = (0, react_1.useRef)(null);
    var categoriesBlocks = (0, apps_shared_1.useGenerateSlideBlocks)({
        cards: preparedCollections,
        cardsInSlide: 5,
        countSlides: 2,
    });
    if (categoriesBlocks.length === 0)
        return null;
    return (react_1.default.createElement("div", { id: "gamesCollections", className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.inner },
            react_1.default.createElement(ui_components_1.TopBar, { title: t('gamesByTheme'), showNavigationButtons: navigationPosition === 'top', navigationPosition: navigationPosition, setPrevSlide: function () { var _a; return (_a = slider === null || slider === void 0 ? void 0 : slider.current) === null || _a === void 0 ? void 0 : _a.slidePrev(); }, setNextSlide: function () { var _a; return (_a = slider === null || slider === void 0 ? void 0 : slider.current) === null || _a === void 0 ? void 0 : _a.slideNext(); }, linkAddress: null }),
            react_1.default.createElement("div", { className: "games-by-theme-slider" },
                react_1.default.createElement(react_2.Swiper, { onBeforeInit: function (swiper) {
                        slider.current = swiper;
                    }, loop: true, spaceBetween: 100, slidesPerView: 1, pagination: { clickable: true }, autoplay: false }, categoriesBlocks.map(function (block, idx) { return (react_1.default.createElement(react_2.SwiperSlide, { key: "slideCollectionGames".concat(idx) },
                    react_1.default.createElement(Slide_1.default, { collections: block, withIcon: withIcon }))); }))),
            navigationPosition === 'bottom' && (react_1.default.createElement("div", { className: styles_module_scss_1.default.bottomBar },
                react_1.default.createElement(ui_components_1.BottomBar, { setPrevSlide: function () { var _a; return (_a = slider === null || slider === void 0 ? void 0 : slider.current) === null || _a === void 0 ? void 0 : _a.slidePrev(); }, setNextSlide: function () { var _a; return (_a = slider === null || slider === void 0 ? void 0 : slider.current) === null || _a === void 0 ? void 0 : _a.slideNext(); }, showNavigationButtons: categoriesBlocks && categoriesBlocks.length > 1, linkAddress: null }))))));
};
exports.default = DesktopGames;
